"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { withBasePath } from "@/lib/base-path";

/**
 * 语言级错误边界。
 *
 * 补建原因（2026-09-13）：此前全库**没有任何 error.tsx / loading.tsx**
 * （精确统计四类同名文件均为 0），即零错误边界 —— 任何客户端异常都会白屏。
 * 在 300s 长任务 + 5s 轮询的交互下，这是流水线页面复杂度上升前必须先补的地基。
 */
export default function LocaleError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations("common");

  useEffect(() => {
    // 保留原始错误到控制台，方便与后端日志/digest 对齐
    console.error("[error-boundary][locale]", error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 p-6 text-center">
      <h1 className="text-lg font-medium text-foreground">{t("errorTitle")}</h1>
      <p className="max-w-md text-sm text-muted-foreground">{t("errorHint")}</p>
      {error.digest ? (
        <p className="font-mono text-xs text-muted-foreground">digest: {error.digest}</p>
      ) : null}
      <div className="mt-2 flex gap-2">
        <Button onClick={() => reset()}>{t("retry")}</Button>
        <Button
          variant="outline"
          onClick={() => {
            window.location.href = withBasePath("/");
          }}
        >
          {t("backHome")}
        </Button>
      </div>
    </div>
  );
}
